module.exports = __webpack_public_path__ + "static/media/MifepristoneOverview.bc21fe2d.docx";